import type { FaireProductEntity } from "../../entity_types/product";

export const p_arqjuh8eyd: FaireProductEntity = {
  token: "p_arqjuh8eyd",
  type: "product",
  name: "Bird House Sorter Box",
  brandToken: "b_2852a5cc",
  brandName: "Jack Rabbit Creations",
  imageUrl:
    "https://cdn.faire.com/fastly/8667a6889bf649f732fccccabeb1a17a8ea3de5d9857b69532b9c0709347d6af.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/326a6c18db73826d33e20a6c4cd4326ccc62aaae4d135b0b0f590b12758214f7.jpeg",
    "https://cdn.faire.com/fastly/621ff263c3d30f8bd41a68486adca2db34d0f1ac8e96ffe585b5c9bf5b0d6269.jpeg",
    "https://cdn.faire.com/fastly/62d0cb1ead4ea167dc285a4b4a09e9740e072bea214757c6eef6d61dcfbaba6f.jpeg",
    "https://cdn.faire.com/fastly/2dbb65766cf880a60b65d0065264128a757af3f31c56eba48a113a54f300db9a.jpeg",
  ],
  priceDollars: 18,
  description:
    "Sorter boxes are a classic toy for early childhood development. Motor skills and matching are engaged as little ones sort the chunky play shapes into the adorable dog house. Birdhouse roof removes for easy storage of the play pieces, and a sturdy wooden handle lets your toddler grab up their favorite toy and take it on an adventure. FSC-certified woods and all non-toxic paints.\n\nAges 18 mos. +",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:03.559Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
